import React, { useRef } from "react";
import { observer } from "mobx-react";
import { Grid, Box } from "@mui/material";
import { GroupContainer } from "../../../../common/components";
import { FormToolbox } from "../../../../common/controls/forms/FormToolbox";
import { useReactToPrint } from "react-to-print";

import { useRootStore } from "../../../../store/contexts";
import { ShowMultiLine } from "../../../common/controls";
import { FormControl } from "@mui/material";

export type CountryViewFormProps = {
  onPrint?: (handlePrint: () => void) => void;
  onCancel?: () => void;
  onEdit?: () => void;
  showToolbox?: boolean;
  name_esValue?: { displayId: string; id: string } | null;
  name_es: string;
  name_enValue?: { displayId: string; id: string } | null;
  name_en: string;
  name_ptValue?: { displayId: string; id: string } | null;
  name_pt: string;
  codeValue?: { displayId: string; id: string } | null;
  code: string;
  currencyValue?: { displayId: string; id: string } | null;
  currency: string;
  demonym_esValue?: { displayId: string; id: string } | null;
  demonym_es: string;
  demonym_enValue?: { displayId: string; id: string } | null;
  demonym_en: string;
  demonym_ptValue?: { displayId: string; id: string } | null;
  demonym_pt: string;
};

export const CountryViewForm: React.FC<CountryViewFormProps> = observer(
  ({
    onPrint = () => {},
    onCancel = () => {},
    onEdit,
    showToolbox = true,
    name_es = "",
    name_en = "",
    name_pt = "",
    code = "",
    currency = "",
    demonym_es = "",
    demonym_en = "",
    demonym_pt = "",
  }) => {
    const rootStore = useRootStore();
    const { langStore } = rootStore;

    const componentRef = useRef(null);
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });

    return (
      <Grid>
        {showToolbox && (
          <FormToolbox
            editForm={onEdit}
            printForm={() => onPrint(handlePrint)}
            closeForm={() => onCancel()}
          />
        )}
        <Box ref={componentRef}>
          <GroupContainer
            id="null"
            title={langStore.groupCountryLabel}
            collapsible={false}
          >
            <FormControl fullWidth>
              <ShowMultiLine
                value={name_es}
                label={langStore.CountryNameLabel + " (es)"}
              />
              ,
              <ShowMultiLine
                value={name_en}
                label={langStore.CountryNameLabel + " (en)"}
              />
              ,
              <ShowMultiLine
                value={name_pt}
                label={langStore.CountryNameLabel + " (pt)"}
              />
              <ShowMultiLine value={code} label={langStore.CountryCodeLabel} />
              <ShowMultiLine
                value={currency}
                label={langStore.CountryCurrencyLabel}
              />
              <ShowMultiLine
                value={demonym_es}
                label={langStore.CountryDemonymLabel + " (es)"}
              />
              ,
              <ShowMultiLine
                value={demonym_en}
                label={langStore.CountryDemonymLabel + " (en)"}
              />
              ,
              <ShowMultiLine
                value={demonym_pt}
                label={langStore.CountryDemonymLabel + " (pt)"}
              />
            </FormControl>
          </GroupContainer>
        </Box>
      </Grid>
    );
  }
);
